export const setRoomName = (name) =>
	({
		type    : 'SET_ROOM_NAME',
		payload : { name }

	});

export const setRoomState = (state) =>
	({
		type    : 'SET_ROOM_STATE',
		payload : { state }

	});

export const setRoomActiveSpeaker = (peerId) =>
	({
		type    : 'SET_ROOM_ACTIVE_SPEAKER',
		payload : { peerId }
	});

export const setActiveScreenId = (screenId, allScreens) =>
	({
		type    : 'SET_SCREEN_ID',
		payload : { screenId, allScreens }
	});

export const setWhiteboardData = (wbData) =>
	({
		type    : 'SET_WB_DATA',
		payload : { wbData }
	});

export const setAllScreens = (allScreens) =>
	({
		type    : 'SET_ALL_SCREENS',
		payload : { allScreens }
	});

export const setRoomLocked = () =>
	({
		type : 'SET_ROOM_LOCKED'
	});

export const setRoomUnLocked = () =>
	({
		type : 'SET_ROOM_UNLOCKED'
	});
export const setJoinDailogStreams = (joinDailogStreams) =>
	({
		type    : 'SET_JOIN_DAILOG_STREAMS',
		payload : { joinDailogStreams }
	});
export const setInAudioAccesble = (isAudioAccessble) =>
	({
		type    : 'SET_IS_AUDIO_ACCESSBLE',
		payload : { isAudioAccessble }
	});
export const setInVideoAccesble = (isVideoAccessble) =>
	({
		type    : 'SET_IS_VIDEO_ACCESSBLE',
		payload : { isVideoAccessble }
	});
export const setfullscreenMode = (fullscreenMode) =>
	({
		type    : 'SET_LAYOUT_FULLSCREEN',
		payload : { fullscreenMode }
	});
export const setInLobby = (inLobby) =>
	({
		type    : 'SET_IN_LOBBY',
		payload : { inLobby }
	});
export const setSessionExp = (sessionExp) =>
	({
		type    : 'SET_SESSION_EXP',
		payload : { sessionExp }
	});
export const handleIgnoreShareRequest = () =>
	({
		type : 'SET_IGNORE_SHARE_REQUEST'
	});
export const handleOpenShareRequest = (openShareRequest) =>
	({
		type    : 'SET_OPEN_SHARE_REQUEST',
		payload : { openShareRequest }
	});

export const setSignInRequired = (signInRequired) =>
	({
		type    : 'SET_SIGN_IN_REQUIRED',
		payload : { signInRequired }
	});

export const setOverRoomLimit = (overRoomLimit) =>
	({
		type    : 'SET_OVER_ROOM_LIMIT',
		payload : { overRoomLimit }
	});

export const setAccessCode = (accessCode) =>
	({
		type    : 'SET_ACCESS_CODE',
		payload : { accessCode }
	});

export const setActivePeerId = (activePeerId) =>
	({
		type    : 'SET_ACTIVEPEERID',
		payload : { activePeerId }
	});

export const setJoinByAccessCode = (joinByAccessCode) =>
	({
		type    : 'SET_JOIN_BY_ACCESS_CODE',
		payload : { joinByAccessCode }
	});

export const setSettingsOpen = (settingsOpen) =>
	({
		type    : 'SET_SETTINGS_OPEN',
		payload : { settingsOpen }
	});

export const setExtraVideoOpen = (extraVideoOpen) =>
	({
		type    : 'SET_EXTRA_VIDEO_OPEN',
		payload : { extraVideoOpen }
	});

export const setRolesManagerOpen = (rolesManagerOpen) =>
	({
		type    : 'SET_ROLES_MANAGER_OPEN',
		payload : { rolesManagerOpen }
	});

export const setRolesManagerPeer = (rolesManagerPeer) =>
	({
		type    : 'SET_ROLES_MANAGER_PEER',
		payload : { rolesManagerPeer }
	});

export const setHelpOpen = (helpOpen) =>
	({
		type    : 'SET_HELP_OPEN',
		payload : { helpOpen }
	});

export const setAboutOpen = (aboutOpen) =>
	({
		type    : 'SET_ABOUT_OPEN',
		payload : { aboutOpen }
	});

export const setTPStatus = (isTelepresense, autoJoin) =>
	({
		type    : 'SET_TP',
		payload : { isTelepresense, autoJoin }
	});

export const setAutoJoin = (autoJoin) =>
	({
		type    : 'SET_AUTOJOIN',
		payload : { autoJoin }
	});

export const enableTelepresence = (telePresenseMenu) =>
	({
		type    : 'SET_TP_MODE',
		payload : { telePresenseMenu }
	});

export const setTPPeers = (tpPeers) =>
	({
		type    : 'TP_PEERS',
		payload : { tpPeers }
	});

export const setLeaveOpen = (leaveOpen) =>
	({
		type    : 'SET_LEAVE_OPEN',
		payload : { leaveOpen }
	});

export const setSettingsTab = (tab) =>
	({
		type    : 'SET_SETTINGS_TAB',
		payload : { tab }
	});

export const setLockDialogOpen = (lockDialogOpen) =>
	({
		type    : 'SET_LOCK_DIALOG_OPEN',
		payload : { lockDialogOpen }
	});

export const setShareDailogOpen = (hostShareDialogOpen) =>
	({
		type    : 'SET_SHARE_DAILOG_OPEN',
		payload : { hostShareDialogOpen }
	});
export const setShareRequestData = (shareRequestdata) =>
	({
		type    : 'SET_SHARE_REQUEST_DATA',
		payload : { shareRequestdata }
	});
export const setAnnotationDailogOpen = (annotationDialog) =>
	({
		type    : 'SET_ANNOTATION_DAILOG_OPEN',
		payload : { annotationDialog }
	});
export const setAnnotationsRequestData = (annotationsRequestData) =>
	({
		type    : 'SET_ANNOTATIONS_REQUEST_DATA',
		payload : { annotationsRequestData }
	});
export const setFileSharingSupported = (supported) =>
	({
		type    : 'FILE_SHARING_SUPPORTED',
		payload : { supported }
	});

export const toggleConsumerWindow = (consumerId) =>
	({
		type    : 'TOGGLE_WINDOW_CONSUMER',
		payload : { consumerId }
	});

export const setToolbarsVisible = (toolbarsVisible) =>
	({
		type    : 'SET_TOOLBARS_VISIBLE',
		payload : { toolbarsVisible }
	});

export const setDisplayMode = (mode) =>
	({
		type    : 'SET_DISPLAY_MODE',
		payload : { mode }
	});

export const addSelectedPeer = (peerId) =>
	({
		type    : 'ADD_SELECTED_PEER',
		payload : { peerId }
	});

export const removeSelectedPeer = (peerId) =>
	({
		type    : 'REMOVE_SELECTED_PEER',
		payload : { peerId }
	});

export const clearSelectedPeers = () =>
	({
		type : 'CLEAR_SELECTED_PEERS'
	});

export const setSpotlights = (spotlights) =>
	({
		type    : 'SET_SPOTLIGHTS',
		payload : { spotlights }
	});

export const clearSpotlights = () =>
	({
		type : 'CLEAR_SPOTLIGHTS'
	});

export const setPagePeers = (pagePeers) =>
	({
		type    : 'SET_PAGE_PEERS',
		payload : { pagePeers }
	});

export const clearPagePeers = () =>
	({
		type : 'CLEAR_PAGE_PEERS'
	});

export const toggleJoined = () =>
	({
		type : 'TOGGLE_JOINED'
	});

export const toggleConsumerFullscreen = (consumerId) =>
	({
		type    : 'TOGGLE_FULLSCREEN_CONSUMER',
		payload : { consumerId }
	});

export const setLobbyPeersPromotionInProgress = (flag) =>
	({
		type    : 'SET_LOBBY_PEERS_PROMOTION_IN_PROGRESS',
		payload : { flag }
	});

export const setMuteAllInProgress = (flag) =>
	({
		type    : 'MUTE_ALL_IN_PROGRESS',
		payload : { flag }
	});

export const setStopAllVideoInProgress = (flag) =>
	({
		type    : 'STOP_ALL_VIDEO_IN_PROGRESS',
		payload : { flag }
	});

export const setStopAllScreenSharingInProgress = (flag) =>
	({
		type    : 'STOP_ALL_SCREEN_SHARING_IN_PROGRESS',
		payload : { flag }
	});

export const setCloseMeetingInProgress = (flag) =>
	({
		type    : 'CLOSE_MEETING_IN_PROGRESS',
		payload : { flag }
	});

export const setClearChatInProgress = (flag) =>
	({
		type    : 'CLEAR_CHAT_IN_PROGRESS',
		payload : { flag }
	});

export const setClearFileSharingInProgress = (flag) =>
	({
		type    : 'CLEAR_FILE_SHARING_IN_PROGRESS',
		payload : { flag }
	});

export const setRoomPermissions = (roomPermissions) =>
	({
		type    : 'SET_ROOM_PERMISSIONS',
		payload : { roomPermissions }
	});

export const setUserRoles = (userRoles) =>
	({
		type    : 'SET_USER_ROLES',
		payload : { userRoles }
	});

export const setAllowWhenRoleMissing = (allowWhenRoleMissing) =>
	({
		type    : 'SET_ALLOW_WHEN_ROLE_MISSING',
		payload : { allowWhenRoleMissing }
	});

export const setHideSelfView = (hideSelfView) =>
	({
		type    : 'SET_HIDE_SELF_VIEW',
		payload : { hideSelfView }
	});

export const setBreakoutRooms = (breakoutRooms) =>
	({
		type    : 'SET_BREAKOUT_ROOMS',
		payload : { breakoutRooms }
	});

export const setBreakoutMainRooms = (breakoutMainRooms) =>
	({
		type    : 'SET_BREAKOUT_MAIN_ROOMS',
		payload : { breakoutMainRooms }
	});

export const setBreakedRooms = (breakedRooms) =>
	({
		type    : 'SET_BREAKED_ROOMS',
		payload : { breakedRooms }
	});

export const setBreakedPeers = (breakedPeers) =>
	({
		type    : 'SET_BREAKED_PEERS',
		payload : { breakedPeers }
	});

export const setBreakoutPeers = (breakoutPeers) =>
	({
		type    : 'SET_BREAKOUT_PEERS',
		payload : { breakoutPeers }
	});

export const setRecordMode = (recordMode) =>
	({
		type    : 'SET_RECORD_MODE_ON',
		payload : { recordMode }
	});

export const setStreamStatus = (streamingOn) =>
	({
		type    : 'SET_STREAMIN_STATUS',
		payload : { streamingOn }
	});
export const setStreamConsentStatus = (streamingConsentStatus) =>
	({
		type    : 'SET_STREAMING_CONSENT_STATUS',
		payload : { streamingConsentStatus }
	});
export const setBroadcastUserStatus = (broadcastUserStatus) =>
	({
		type    : 'SET_BROADCAST_USER_STATUS',
		payload : { broadcastUserStatus }
	});
export const setFaceBookStreamStatus = (facebookStreamStatus) =>
	({
		type    : 'SET_FACEBOOK_STREAM_STATUS',
		payload : { facebookStreamStatus }
	});
export const setYoutubeStreamStatus = (youtubeStreamStatus) =>
	({
		type    : 'SET_YOUTUBE_STREAM_STATUS',
		payload : { youtubeStreamStatus }
	});
export const setLiveStreamingOn = (streamingLiveOn) =>
	({
		type    : 'SET_LIVE_STREAMING_STATUS',
		payload : { streamingLiveOn }
	});
export const setEnableDisableCloudRecording = (cloudRecordingStatus) =>
	({
		type    : 'SET_ENABLE_DISABLE_CLOUD_RECORDING',
		payload : { cloudRecordingStatus }
	});
export const setRecordingConsent = (cloudRecordingConsentStatus) =>
	({
		type    : 'SET_RECORDING_CONSENT',
		payload : { cloudRecordingConsentStatus }

	});
export const setTranscriptionConsent = (transcriptionConsentStatus) =>
	({
		type    : 'SET_TRANSCRIPTION_CONSENT',
		payload : { transcriptionConsentStatus }

	});
export const setCloudRecordingLiveStatus = (cloudRecordingLiveStatus) =>
	({
		type    : 'SET_LIVE_CLOUD_RECORD_STATUS',
		payload : { cloudRecordingLiveStatus }
	});
export const setBackgroundOpen = (backgroundOpen) =>
	({
		type    : 'SET_BACKGROUND_OPEN',
		payload : { backgroundOpen }
	});
export const setTemplateStream = (templateStreamOn) =>
	({
		type    : 'SET_TEMPLATE_STREAM_STATUS',
		payload : { templateStreamOn }
	});
export const setBackgroundDialog = (backgroundDialogOpen) =>
	({
		type    : 'SET_BACKGROUND_DIALOG_OPEN',
		payload : { backgroundDialogOpen }
	});
export const setVirtualBgDetails = (img, blur) =>
	({
		type    : 'SET_VIRTUAL_BG_DETAILS',
		payload : { img, blur }
	});
export const setS3VirtualBGImages = (s3VirtualBGImages) =>
	({
		type    : 'SET_S3_VIRTUAL_BG_IMAGES',
		payload : { s3VirtualBGImages }
	});
export const deleteS3VirtualBGImage = (deleteS3VirtualBGImages) =>
	({
		type    : 'DELETE_S3_VIRTUAL_BG_IMAGES',
		payload : { deleteS3VirtualBGImages }
	});
export const setTemplateLeaveOpen = (templateLeaveOpen) =>
	({
		type    : 'SET_TEMPLATE_LEAVE_OPEN',
		payload : { templateLeaveOpen }
	});
export const setModeratorClose = (moderatorCloseMeeting) =>
	({
		type    : 'SET_CLOSE_MEETING_OPEN',
		payload : { moderatorCloseMeeting }
	});
export const setRecordingLicense = (recordingLicense) =>
	({
		type    : 'SET_RECORDING_LICENSE',
		payload : { recordingLicense }
	});
export const setStreamingLicense = (streamingLicense) =>
	({
		type    : 'SET_STREAMING_LICENSE',
		payload : { streamingLicense }
	});
export const setCloudRecordingLicense = (cloudRecordingLicense) =>
	({
		type    : 'SET_CLOUD_RECORDING_LICENSE',
		payload : { cloudRecordingLicense }
	});
export const setBroadcastDialogOpen = (broadcastDialogOpen) =>
	({
		type    : 'SET_BROADCAST_DIALOG_OPEN',
		payload : { broadcastDialogOpen }
	});
export const handleIgnoreMasking = (ignoreMasking) =>
	({
		type    : 'SET_IGNORE_MASKING',
		payload : { ignoreMasking }
	});
export const handleIsPipMode = (isInPipMode) =>
	({
		type    : 'SET_PIP_ISINPIP',
		payload : { isInPipMode }
	});
export const setMDeviceId = (mDeviceType) =>
	({
		type    : 'SET_DEVICE_TYPE',
		payload : { mDeviceType }
	});

export const setBreakoutPopup = (breakoutPopup) =>
	({
		type    : 'SET_BREAKOUT_POPUP',
		payload : { breakoutPopup }
	});
export const createRoomsNew = (createRoomsDataNew) =>
	({
		type    : 'SET_CREATE_ROOMS_NEW',
		payload : { createRoomsDataNew }
	});
export const setBreakedRoomsNew = (breakoutRoomsNewList) =>
	({
		type    : 'SET_BREAKOUT_ROOMS_NEW',
		payload : { breakoutRoomsNewList }
	});
export const handleBreakoutRoomPeers = (breakoutRoomPeers) =>
	({
		type    : 'SET_BREAKOUT_ROOM_PEERS',
		payload : { breakoutRoomPeers }
	});
export const handleBreakoutRoomHostList = (breakoutRoomHost) =>
	({
		type    : 'SET_BREAKOUT_ROOM_HOST',
		payload : { breakoutRoomHost }
	});
export const setVirtualBg = (virtualBg) =>
	({
		type    : 'SET_BACKGROUND_IMG',
		payload : { virtualBg }
	});
export const setIsLanguageDropdown = (isChangeLanguageDropdown) =>
	({

		type    : 'SET_IS_DROPDOWN_LANGUAGE',
		payload : { isChangeLanguageDropdown }
	});
// export const setLiveStreamPopup = (liveStreamOpen) =>
// 	({
// 		type    : 'SET_LIVESTREAM_OPEN',
// 		payload : { liveStreamOpen }
// 	});
export const setYoutubeStreamData = (youtubeStreamData) =>
	({
		type    : 'SET_YOUTUBE_STREAM_DATA',
		payload : { youtubeStreamData }
	});
export const setFacebookStreamData = (facebookStreamData) =>
	({
		type    : 'SET_FACEBOOK_STREAM_DATA',
		payload : { facebookStreamData }
	});
export const setLiveStreamOpen = (liveStreamOpen) =>
	({
		type    : 'SET_LIVE_STREAM_OPEN',
		payload : { liveStreamOpen }
	});
export const setWebinarPeers = (webinarPeers) =>
	({
		type    : 'SET_WEBINAR_PEERS',
		payload : { webinarPeers }
	});
export const deleteWebinarPeers = (id) =>
	({
		type    : 'DELETE_WEBINAR_PEERS',
		payload : { id }
	});
export const setMeScreenShareHide = (meScreenShareHide) =>
	({
		type    : 'SET_ME_SCREEN_SHARE_HIDE',
		payload : { meScreenShareHide }
	});
export const setPermissionRelaodPopUp = (permissionReloadPopUp) =>
	({
		type    : 'SET_PERMISSION_RELOAD_POP_UP',
		payload : { permissionReloadPopUp }
	});
export const setIsBreakoutRoomStart = (isBreakoutRoomStart) =>
	({
		type    : 'SET_IS_BREAKOUTROOM_START',
		payload : { isBreakoutRoomStart }
	});
export const setEndBreakoutSession = (endBreakoutSession) =>
	({
		type    : 'SET_ENDBREAKOUTROOM_SESSION',
		payload : { endBreakoutSession }
	});
export const setBreakoutRoomJoin = (breakoutJoin) =>
	({
		type    : 'SET_BREAKOUT_JOIN',
		payload : { breakoutJoin }
	});
export const setIsBreakoutRoomJoin = (isBreakoutRoomJoin) =>
	({
		type    : 'SET_ISBREAKOUTROOM_JOIN',
		payload : { isBreakoutRoomJoin }
	});
export const setDocument = (uploadDocument) =>
	({
		type    : 'SET_DOCUMENT',
		payload : { uploadDocument }
	});
export const setPage = (page) =>
	({
		type    : 'SET_PAGE',
		payload : { page }
	});
export const setZoom = (zoom) =>
	({
		type    : 'SET_ZOOM',
		payload : { zoom }
	});
export const setTotalPages = (totalPages) =>
	({
		type    : 'SET_TOTALPAGES',
		payload : { totalPages }
	});
export const setShareOpen = (isShareOpen) =>
	({
		type    : 'SET_SHARE_OPEN',
		payload : { isShareOpen }
	});
export const setVideoData = (videoData) =>
	({
		type    : 'SET_VIDEO_DATA',
		payload : { videoData }
	});
export const setScrollValue = (diff) => ({
	type    : 'SET_SCROLL_VALUE',
	payload : diff
});

export const setIsPip = (isPip) => ({
	type    : 'SET_ISPIP',
	payload : isPip
});

export const setPipActiveSpeaker = (pipActiveSpeaker) => ({
	type    : 'SET_PIP_ACTIVESPEAKER',
	payload : pipActiveSpeaker
});
export const setMeetData = (meetDetails) => ({
	type    : 'SET_MEET_DATA',
	payload : meetDetails
});
export const setWebinarStreamOn = (webinarStreamOn) => ({
	type    : 'WEBINAR_STREAM_ON',
	payload : webinarStreamOn
});
export const setShareLink = (shareLink) => ({
	type    : 'SET_SHARE_LINK',
	payload : shareLink
});

export const setShareType= (shareType) => ({
	type    : 'SET_SHARE_TYPE',
	payload : shareType
});

export const setIsTranscriptionStart= (isTranscriptionStart) => ({
	type    : 'SET_IS_START_TRANSCRIPT',
	payload : { isTranscriptionStart }
});

export const setIsEnableCC= (isEnableCC) => ({
	type    : 'SET_ENABLE_CC',
	payload : { isEnableCC }
});
export const setEndOrLeave = (endOrLeave) => ({
	type    : 'SET_ENDORLEAVE',
	payload : endOrLeave
});
export const setisViewTranscription = (viewTranscription) => ({
	type    : 'VIEW_TRANSCIPTION',
	payload : viewTranscription
});
export const setAuthToken = (token) => ({
	type    : 'SET_AUTH_TOKEN',
	payload : token
});
export const setUserId = (userID) => ({
	type    : 'SET_USERID',
	payload : userID
});
export const setSelectedFiles = (selectedFiles) => ({
	type    : 'SET_SELECTED_FILE',
	payload : selectedFiles
});
export const setSyncOrAsync = (syncOrAsync) =>
	({
		type    : 'SET_IS_SYNC_OR_ASYNC',
		payload : { syncOrAsync }
	});
export const setTelepresenseStart = (isTelepresenseStart) =>
	({
		type    : 'SET_IS_TELEPRESENSE_START',
		payload : { isTelepresenseStart }
	});
export const setTpScreenPresentationView = (tpScreenPresentationView) =>
	({
		type    : 'SET_TP_SCREEN_PRESENTATIONVIEW',
		payload : { tpScreenPresentationView }
	});
export const setLiveTpScreens = (liveTpScreens) =>
	({
		type    : 'SET_LIVE_TP_SCREENS',
		payload : { liveTpScreens }
	});
export const setPoolsubmittedData = (pollSubmittedData) =>
	({
		type    : 'SET_POLL-SUBMITTED-DATA',
		payload : { pollSubmittedData }
	});
export const setTpScreensPeerData = (tpScreensData) =>
	({
		type    : 'SET_TP_SCREENS_DATA',
		payload : { tpScreensData }
	});
export const setPeersToScreensPages = (tpScreenPagePeers) =>
	({
		type    : 'SET_PEERS_TO_SCREEN_PAGES',
		payload : { tpScreenPagePeers }
	});
export const setshowScreenSharePopUp = (showScreenSharePopUp) => ({
	type    : 'SET_SHOW_SCREENSHARE_POPUP',
	payload : showScreenSharePopUp
});
export const setIsScreenshareAccept = (isScreenshareAccepted) => ({
	type    : 'SET_SCREENSHARE_ACCEPTED',
	payload : isScreenshareAccepted
});
export const updateSIPURI = (sipURI) =>
	({
		type    : 'SET_SIP_URI',
		payload : { sipURI }
	});
export const updateCallerURI = (callerURI) =>
	({
		type    : 'SET_CALLER_URI',
		payload : { callerURI }
	});
export const openSIPIncomingCallReq = (openSipIncomingreq) =>
	({
		type    : 'OPEN_SIP_INCOMING_REQ',
		payload : { openSipIncomingreq }
	});
export const acceptRejectIncomingCall = (dialDialOutCalls) =>
	({
		type    : 'ACCEPT_REJECT_INCOMING_CALL',
		payload : { dialDialOutCalls }
	});
export const updateSipUserCallStatus = (peerId) =>
	({
		type    : 'UPDATE_SIP_USER_CALL_STATUS',
		payload : { peerId }
	});
export const setSIPCallingOpen = (openSipCalling) =>
	({
		type    : 'SET_SIP_CALLING_OPEN',
		payload : { openSipCalling }
	});
export const setSIPAutoAcceptCalls = (isSipAutoAcceptCalls) =>
	({
		type    : 'SET_SIP_AUTO_ACCEPT_CALLS',
		payload : { isSipAutoAcceptCalls }
	});
export const setSIPCallsLimit = (sipcallsLimit) =>
	({
		type    : 'SET_SIP_CALLS_LIMIT',
		payload : { sipcallsLimit }
	});
export const setSIPConferenceUsers = (SIPConferenceUsers) =>
	({
		type    : 'SET_SIP_CONFERENCE_USERS',
		payload : { SIPConferenceUsers }
	});
export const setSIPConferenceUserMuteActions = ({ id, status, actionType }) =>
	({
		type    : 'SET_SIP_CONFERENCE_USERS_MUTE_ACTIONS',
		payload : { id, status, actionType }
	});
export const handleSIPMuteAll = (sipMuteAll) =>
	({
		type    : 'HANDLE_SIP_MUTE_ALL',
		payload : { sipMuteAll }
	});
export const handleSIPSpotlight = (sipSpotlightPeerId) =>
	({
		type    : 'HANDLE_SIP_SPOTLIGHTS',
		payload : { sipSpotlightPeerId }
	});

export const setRoomToken = (roomToken) => ({
	type    : 'SET_ROOM_TOKEN',
	payload : roomToken
});

export const setRoomType = (scheduleType) => ({
	type    : 'SET_SCHEDULE_TYPE',
	payload : scheduleType
});

export const setCallType = (callType) => ({
	type    : 'SET_CALL_TYPE',
	payload : callType
});

export const setSessionName = (sessionName) => ({
	type    : 'SET_SESSION_NAME',
	payload : sessionName
});

export const setRoomCreationTime = (roomCreationTime) => ({
	type    : 'SET_ROOM_CREATION_TIME',
	payload : roomCreationTime
});
export const setConferenceMuteAction = (conferenceMuteAction) => ({
	type    : 'SET_CONFERENCE_MUTE_ACTION',
	payload : conferenceMuteAction
});

export const setTranscriptionHealth = (transcriptionHealth) => ({
	type    : 'SET_TRANSCRIPTION_HEALTH',
	payload : transcriptionHealth
});

export const setCameraControlEvent = (camera) => ({
	type    : 'SET_CAMERA_CONTROL',
	payload : camera
});
export const setCameraControlId = (cameraControlId) => ({
	type    : 'SET_CAMERA_CONTROL_ID',
	payload : cameraControlId
});
export const setCameraRequestDialog = (cameraRequestDialog) => ({
	type    : 'SET_CAMERA_REQUEST_DIALOG',
	payload : cameraRequestDialog
});